import {
  Form,
  Input,
  Select,
  AutoComplete,
  Button,
  Card,
  Spin,
  Icon,
  InputNumber,
  TimePicker,
  Checkbox,
  Popconfirm,
} from "antd";
import React, { Component } from "react";
import { showSuccessToast } from "../general/ToastHelper";
import withSharedStateConsumer from "../../contexts/shared-state/withSharedStateConsumer";
import { withRouter } from "react-router-dom";
import { handleError } from "../../utils/ErrorHandlers";
import Page from "../general/Page";
import { AccountGroupService } from "../../services/group/AccountGroupService";
import { FileService } from "../../services/file/FileService";
import { CfgAccountService } from "../../services/cfgAccount/CfgAccountService";
import { CfgOneStepService } from "../../services/cfgOneStep/CfgOneStepService";
import { AccountService } from "../../services/account/AccountService";
import UsersTable from "../../components/user/UsersTable";
import { UserService } from "../../services/user/UserService";
import { convertTZToUTCs } from "../general/DateTzHelper";
import "./UpdateGroupAccount.css";
import moment from "moment-timezone";
import { Translation } from "react-i18next";
import i18next from "i18next";
import { fi } from "date-fns/locale";
import { file } from "jszip";
class UpdateGroupAccount extends Component {
  constructor(props) {
    super(props);
    this.props.context.setCurrentComponent("editGroups");
    this.fileService = new FileService();
    this.cfgAccountService = new CfgAccountService();
    this.acc = new AccountGroupService();
    this.cfgOneStep = new CfgOneStepService();
    this.groupService = new AccountGroupService();

    this.state = {
      groupAccount: { cfg: {} },
      formLayout: "inline",
      loading: false,
      agentsNumber: [],
      callFlowsList: [],
      cfg: {},
      selectedValueCallFlowId: "",
      selectedNumberOfConcurrentCalls: "",
      oldNumberOfConcurrentCalls: "",
      selectedValueGroupNumbers: [],
      numberOfConcCalls: "",
      selectedValueSM: "",
      isFetching: false,
      usersNumbers: [],
      selectedValueReadyFlow: "",
      accountUsers: [],
      selectedAgentNumberForAgentGroup: "",
      selectedAgentNumberOfConcCalls: 0,
      accountNumberOfConcurrentCalls: 0,
      IBGNumberOfConcurrentCalls: 0,
      prompts: [],
      activateVoiceMail: false,
      startHour: "",
      endHour: "",
      selectedVoiceMailMessage: "",
      workingDays: null,
      readyFlow: false,
      allGroups: [],
      agentGroups: [],
      cfgOneStep: {},
      selectedVoiceMailMessageForView: "",
      numberAlreadyAssignedToGroups:[]
    };
  }
  async getAccountUsers() {
    this.acc = new UserService();
    try {
      let data = await this.acc.getAllUsersByAccountIdService(
        this.props.context.session_id,
        this.props.context.user.accountId
      );
      return data;
    } catch (e) {
      throw e;
    }
  }
  async getAllPrompts() {
    try {
      let data = await this.fileService.getPromptsService(
        this.props.context.session_id
      );
      return data;
    } catch (e) {
      throw e;
    }
  }
  async getAllGroups() {
    try {
      let data = await this.groupService.getAccountGroups(
        this.props.context.session_id
      );
      return data;
    } catch (e) {
      throw e;
    }
  }
  async getCfgOneStep() {
    let { id } = this.props.match.params;

    try {
      let data = await this.cfgOneStep.getCfgOneStepByIBG(
        this.props.context.session_id,
        this.props.context.user.accountId,
        id
      );
      return data;
    } catch (e) {
      throw e;
    }
  }

  async componentDidMount() {
    let {
      selectedNumberOfConcurrentCalls,
      oldNumberOfConcurrentCalls,
      selectedValueCallFlowId,
      selectedValueGroupNumbers,
      selectedValueSM,
      selectedValueReadyFlow,
      selectedAgentNumberForAgentGroup,
      IBGNumberOfConcurrentCalls,
      selectedAgentNumberOfConcCalls,
      activateVoiceMail,
      startHour,
      endHour,
      selectedVoiceMailMessage,
      workingDays,
      allGroups,
      agentGroups,
      cfgOneStep,
      selectedVoiceMailMessageForView,
    } = this.state;
    try {
      this.setState({ isFetching: true });
      let [
        groupAccount,
        callFlowsList,
        account,
        accountUsers,
        prompts,
        allGroups,
        cfgOneStep,
      ] = await Promise.all([
        this.getGroupAccountData(),
        this.getAllCallFlow(),
        this.getAccountData(),
        this.getAccountUsers(),
        this.getAllPrompts(),
        this.getAllGroups(),
        this.getCfgOneStep(),
      ]);

      let agentGroups = allGroups.ivrList.filter(
        (item) => item.groupType === "SXG"
      );
    
      
      groupAccount.cfg.forEach((element) => {
        if (
          Object.getOwnPropertyNames(element).indexOf("MAX_CONCURRENT_CALLS") >
          -1
        ) {
          selectedNumberOfConcurrentCalls = element["MAX_CONCURRENT_CALLS"];
          oldNumberOfConcurrentCalls = element["MAX_CONCURRENT_CALLS"];
        }
        if (Object.getOwnPropertyNames(element).indexOf("CALL_FLOW") > -1) {
          let selectedCallFlow = callFlowsList.filter((elem)=>{
            let fileId =  element["CALL_FLOW"].split(".icf")[0];
              return elem.fileId == fileId
            
          })
          selectedValueCallFlowId = selectedCallFlow.length !=0 ? selectedCallFlow[0].name : element["CALL_FLOW"];
        }
        if (Object.getOwnPropertyNames(element).indexOf("GROUP_NUMBERS") > -1) {
          selectedValueGroupNumbers = element["GROUP_NUMBERS"].split(",");
        }
        if (Object.getOwnPropertyNames(element).indexOf("SWITCH_MODE") > -1) {
          selectedValueSM = element["SWITCH_MODE"];
        }
        if (Object.getOwnPropertyNames(element).indexOf("READY_FLOW") > -1) {
          selectedValueReadyFlow = element["READY_FLOW"];
        }
        if (
          Object.getOwnPropertyNames(element).indexOf("MAX_CONCURRENT_CALLS") >
          -1
        ) {
          selectedAgentNumberOfConcCalls = element["MAX_CONCURRENT_CALLS"];
        }
        if (
          Object.getOwnPropertyNames(element).indexOf(
            "AVAILABLE_CONCURRENT_CALLS"
          ) > -1
        ) {
          IBGNumberOfConcurrentCalls = element["AVAILABLE_CONCURRENT_CALLS"];
        }
        if (
          Object.getOwnPropertyNames(element).indexOf("ACTIVATE_VOICEMAIL") > -1
        ) {
          activateVoiceMail =
            element["ACTIVATE_VOICEMAIL"] === "true" ? true : false;
        }
        if (
          Object.getOwnPropertyNames(element).indexOf("END_WORKING_HOUR") > -1
        ) {
          endHour = element["END_WORKING_HOUR"];
        } //else {
        //   groupAccount.cfg.push({
        //     END_WORKING_HOUR: "",
        //     configCategory: "CTI",
        //   });
        //   endHour = element["END_WORKING_HOUR"];
        // }
        if (
          Object.getOwnPropertyNames(element).indexOf("START_WORKING_HOUR") > -1
        ) {
          startHour = element["START_WORKING_HOUR"];
        } //else {
        //   groupAccount.cfg.push({
        //     START_WORKING_HOUR: "",
        //     configCategory: "CTI",
        //   });
        //   startHour = element["END_WORKING_HOUR"];
        // }
        if (
          Object.getOwnPropertyNames(element).indexOf("VOICEMAIL_PROMPT") > -1
        ) {
          selectedVoiceMailMessage = element["VOICEMAIL_PROMPT"];
        }
        if (Object.getOwnPropertyNames(element).indexOf("WORKING_DAYS") > -1) {
          workingDays = element["WORKING_DAYS"];
        }
      });
      let cfg = { agents_nums: [] };
      let result =[]
      let numberAlreadyAssignedToGroups =[];
      if(account.ivrCustomEntityObject.cfgGroup.length){
        account.ivrCustomEntityObject.cfgGroup.forEach((elem)=>{
          if (
            Object.getOwnPropertyNames(elem).indexOf("GROUP_NUMBERS") > -1
          ) {
          numberAlreadyAssignedToGroups.push(elem["GROUP_NUMBERS"]);
          }
        })
      }
      if (account.ivrCustomEntityObject.cfg.length) {
        account.ivrCustomEntityObject.cfg.forEach((element) => {
          if (
            Object.getOwnPropertyNames(element).indexOf("ACCOUNT_NUMBERS") > -1
          ) {
            if (element["ACCOUNT_NUMBERS"] === "") {
              cfg.account_nums = [];
            } else {
              cfg.account_nums = element["ACCOUNT_NUMBERS"].split(",");
               result = cfg.account_nums.filter(element => !numberAlreadyAssignedToGroups.includes(element));
               result.push(selectedValueGroupNumbers); 
              
            }
          }
          if (
            Object.getOwnPropertyNames(element).indexOf(
              "MAX_CONCURRENT_CALLS"
            ) > -1
          ) {
            cfg.accountNumberOfConcurrentCalls =
              element["MAX_CONCURRENT_CALLS"];
          }
        });

       
      }
      this.setState({
        callFlowsList: callFlowsList,
        account: account.ivrCustomEntityObject,
        cfg: cfg,
        usersNumbers: result,
        isFetching: false,
        groupAccount: groupAccount,
        selectedNumberOfConcurrentCalls,
        oldNumberOfConcurrentCalls,
        selectedValueCallFlowId,
        selectedValueGroupNumbers,
        selectedValueSM,
        selectedValueReadyFlow,
        accountUsers: accountUsers.ivrList,
        accountNumberOfConcurrentCalls: cfg.accountNumberOfConcurrentCalls,
        selectedAgentNumberForAgentGroup,
        selectedAgentNumberOfConcCalls,
        activateVoiceMail,
        IBGNumberOfConcurrentCalls,
        startHour,
        endHour,
        selectedVoiceMailMessage,
        workingDays,
        prompts: prompts.ivrList,
        agentGroups: agentGroups,
        cfgOneStep: cfgOneStep.ivrCustomEntityObject,
        readyFlow: selectedValueReadyFlow !== "None" ? true : false,
        selectedVoiceMailMessageForView,
      });
      if (this.state.groupAccount.groupType == "IBG" && cfgOneStep.ivrCustomEntityObject !=null) {
        let cfgOneStepCopy = this.state.cfgOneStep;
        this.state.prompts.forEach((element) => {
          if (element.fileId == cfgOneStepCopy.welcomePrompt.split(".wav")[0]) {
            this.setState((prevState) => ({
              cfgOneStep: {
                ...prevState.cfgOneStep,
                welcomePrompt: element.name,
              },
            }));
          }
          if (element.fileId == cfgOneStepCopy.waitingPrompt.split(".wav")[0]) {
            this.setState((prevState) => ({
              cfgOneStep: {
                ...prevState.cfgOneStep,
                waitingPrompt: element.name,
              },
            }));
          }
        });
      }

      if (this.state.activateVoiceMail) {
        this.state.prompts.forEach((element, i) => {
          if (element.fileId == selectedVoiceMailMessage.split(".wav")[0] || element.name == selectedVoiceMailMessage) {
            this.setState({ selectedVoiceMailMessageForView: element.name });
          }
        });
      }
      // let numberOfConcCalls = await this.getNumberOfConcCalls();
      // this.setState({
      //   numberOfConcCalls,
      // });
    } catch (e) {
      this.setState({ isFetching: false });
      handleError(e);
    }
  }

  async getAccountData() {
    this.acc = new AccountService();
    try {
      let account = await this.acc.getAccountsByIdService(
        this.props.context.session_id,
        this.props.context.user.accountId
      );
      return account;
    } catch (e) {
      throw e;
    }
  }
  async getGroupAccountData() {
    let { id } = this.props.match.params;

    try {
      let response = await this.acc.getGroupByAccountIdAndGroupIdService(
        this.props.context.session_id,
        id
      );
      return response.ivrCustomEntityObject;
    } catch (e) {
      throw e;
    }
  }

  handleRefresh() {}
  handleDropdownChange(value) {
    let { groupAccount } = this.state;
    groupAccount.groupType = value;
    this.setState({ groupAccount });
  }
  handleConCallDropdownChange(value) {}
  async getAllCallFlow() {
    try {
      let data = await this.fileService.getCallFlowsService(
        this.props.context.session_id
      );
      return data.ivrList;
    } catch (e) {
      throw e;
    }
  }
  handleActivateVoiceCheckBox(e) {
    let isChecked = false;
    if (e.target.checked === true) {
      isChecked = true;
    } else {
      isChecked = false;
    }
    this.setState({ activateVoiceMail: isChecked });
  }

  handleReadyFlowCheckBox(e) {
    let { readyFlow } = this.state;
    readyFlow = e.target.checked === true ? true : false;
    if (!readyFlow) {
      this.props.form.setFields({
        CallFlow: {
          value: "",
        },
      });
    } else {
      this.props.form.setFields({
        CallFlow: {
          value: "CF_Ready_Flow",
        },
      });
    }

    this.setState({ readyFlow });
  }

  handleWorkingdDaysChange(values) {}
  handleStatusChange(value) {
    let { groupAccount } = this.state;
    groupAccount.groupStatus = value;
    this.setState({ groupAccount });
  }
  handleChangeAgentsNumberForAgentGroup = (
    selectedAgentNumberForAgentGroup
  ) => {
    this.setState({ selectedAgentNumberForAgentGroup });
  };
  handleChangeAgentNumberOfConcCalls = (selectedAgentNumberOfConcCalls) => {
    this.setState({ selectedAgentNumberOfConcCalls });
  };
  handleConfirm = (e) => {
    e.preventDefault();
    let history = this.props.history;
    let accountId = this.props.context.user.accountId;
    let { groupAccount } = this.state;

    this.props.form.validateFields(async (err, values) => {
      try {
        if (!err) {
          this.setState({ loading: true });
          this.acc = new AccountGroupService();
         

          this.state.prompts.forEach((element) => {
            if (element.name == values.voiceMailMessage) {
              values["voiceMailMessage"] = element.fileId;
            }
          });
          this.state.callFlowsList.forEach((element)=>{
            if(element.name == values.CallFlow){
              values["CallFlow"] = element.fileId
            }
          })
          values["CallFlow"]=values.CallFlow =="" ? values.CallFlow : values.CallFlow+".icf"
         
          values["accountId"] = accountId;
          values["groupId"] = groupAccount.groupId;

          values["groupType"] = groupAccount.groupType;
          let cfg = [];
          if (values.groupType == "IBG") {
            values["groupStatus"] =
              values.readyFlow || values.CallFlow
                ? groupAccount.groupStatus
                : "SUS";
            cfg = [
              {
                key: "MAX_CONCURRENT_CALLS",
                value: values.numberOfConcCalls,
                configCategory: "CTI",
              },
              {
                key: "GROUP_NUMBERS",
                value: "" + this.state.selectedValueGroupNumbers,
                configCategory: "CTI",
              },
              {
                key: "READY_FLOW",
                value: values.readyFlow ? "ONE_STEP" : "None",
                configCategory: "CTI",
              },
              {
                key: "CALL_FLOW",
                value: values.readyFlow ? "CFL.ONE_STEP" : values.CallFlow,
                configCategory: "CTI",
              },
              {
                key: "ACTIVATE_VOICEMAIL",
                value: values.activateVoicemail,
                configCategory: "CTI",
              },
              {
                key: "START_WORKING_HOUR",
                value: values.startWorkingHour
                  ? convertTZToUTCs(values.startWorkingHour)
                  : "",
                configCategory: "CTI",
              },
              {
                key: "END_WORKING_HOUR",
                value: values.endWorkingHour
                  ? convertTZToUTCs(values.endWorkingHour)
                  : "",
                configCategory: "CTI",
              },
              {
                key: "VOICEMAIL_PROMPT",
                value: values.voiceMailMessage
                  ? values.voiceMailMessage + ".wav"
                  : "",
                configCategory: "CTI",
              },
              {
                key: "WORKING_DAYS",
                value: values.workingDays ? values.workingDays.toString() : "",
                configCategory: "CTI",
              },
              {
                key: "OLD_MAX_CONCURRENT_CALLS",
                value: this.state.oldNumberOfConcurrentCalls,
                configCategory: "CTI",
              },
            ];
          }

          if (values.groupType == "SXG") {
            values["groupStatus"] = groupAccount.groupStatus;
            cfg = [
              {
                key: "SWITCH_MODE",
                value: this.state.selectedValueSM,
                configCategory: "CTI",
              },
            ];
          }
          values["isReadyFlow"] = this.state.readyFlow && values.groupType === "IBG" ? true :false;

         

          if (this.state.readyFlow && values.groupType == "IBG") {
            this.state.prompts.forEach((element) => {
              if (element.name == values.welcomePrompt) {
                values["welcomePrompt"] = element.fileId;
              }
              if (element.name == values.waitingPrompt) {
                values["waitingPrompt"] = element.fileId;
              }
            });

            let record = {
              accountId: this.props.context.user.accountId,
              ibgGroupId: groupAccount.groupId,
              sxgGroupId: values.sxgGroupId,
              welcomePrompt: values.welcomePrompt + ".wav",
              waitingPrompt: values.waitingPrompt + ".wav",
            };
            values["cfgOneStep"] = record;

      
          }
          console.log(values["isReadyFlow"])

          let data = await this.acc.editGroupAccount(
            this.props.context.session_id,
            values,
            cfg
          );

          this.setState({ loading: false });
          showSuccessToast(
            i18next.t("Update Group Account ") + i18next.t(data.statusMsg)
          );

          history.push("/home/groups/");
        }
      } catch (e) {
        this.setState({ loading: false });
        handleError(e);
      }
    });
  };
  handleSMDropdownChange(value) {
    let { selectedValueSM } = this.state;
    selectedValueSM = value;

    this.setState({ selectedValueSM });
  }

  async getNumberOfConcCalls() {
    try {
      let data = await this.cfgAccountService.getCurrentConcurrentCalls(
        this.props.context.session_id,
        this.state.groupAccount.groupId
      );
      return data.ivrCustomEntityObject;
    } catch (e) {
      throw e;
    }
  }
  // mapWorkingDays(items) {

  //   items = items.split(",");
  //   let days = [];
  //   items.forEach((index) => {
  //     switch (index) {
  //       case "0":
  //         days.push("Sunday");
  //         break;
  //       case "1":
  //         days.push("Monday");
  //         break;
  //       case "2":
  //         days.push("Tuesday");
  //         break;
  //       case "3":
  //         days.push("Wednesday");
  //         break;
  //       case "4":
  //         days.push("Thursday");
  //         break;
  //       case "5":
  //         days.push("Friday");
  //         break;
  //       case "6":
  //         days.push("Saturday");
  //         break;
  //       default:
  //         break;
  //     }
  //   });

  //   return days;
  // }

  handleChangeAgentsNumber = (selectedValueGroupNumbers) => {
    this.setState({ selectedValueGroupNumbers });
  };
  render() {
    let {
      isFetching,
      selectedValueGroupNumbers,
      numberOfConcCalls,
      callFlowsList,
      groupAccount,
      selectedValueSM,
      selectedNumberOfConcurrentCalls,
      usersNumbers,
      selectedValueReadyFlow,
      selectedAgentNumberForAgentGroup,
      accountUsers,
      IBGNumberOfConcurrentCalls,
      accountNumberOfConcurrentCalls,
      workingDays,
      prompts,
      agentGroups,
    } = this.state;

    const { Option } = Select;
    const format = "HH:mm";

    const promptOptions = prompts.map((opt) => (
      <Option key={opt.fileId} value={opt.fileId}>
        {opt.name}
      </Option>
    ));
    const { getFieldDecorator } = this.props.form;
    const formItemLayout = {
      labelCol: { span: 6 },
      wrapperCol: { span: 14 },
    };

    // const filteredOptions = this.state.usersNumbers.filter(
    //   o => !this.state.selectedValueGroupNumbers.includes(o)
    // );
    const options = callFlowsList.map((opt) => (
      <Option key={opt.name} value={opt.fileId}>
        {opt.name}
      </Option>
    ));

    const agentGroupOptions = agentGroups.map((opt) => (
      <Option key={opt.groupId} value={opt.groupId}>
        {opt.groupName}
      </Option>
    ));

    const numberOfConcCallsList = [];
    for (let i = 1; i <= IBGNumberOfConcurrentCalls; i++) {
      numberOfConcCallsList.push(
        <Option key={i} value={i}>
          {i}
        </Option>
      );
    }
    return (
      <Translation>
        {(t) => (
          <Page title={t("Update Group")} hasBackArrow={true}>
            {isFetching ? (
              <Spin></Spin>
            ) : (
              <div>
                <Card
                  style={{
                    marginTop: "10px",
                    boxShadow: "0 2px 8px rgba(0, 0, 0, 0.15)",
                  }}
                  bordered={false}
                >
                  <Form className="form-style" {...formItemLayout}>
                    <Form.Item
                      style={{ marginTop: "20px" }}
                      label={t("Group Name")}
                      {...formItemLayout}
                    >
                      {getFieldDecorator(
                        "groupName",

                        {
                          initialValue: groupAccount.groupName,

                          rules: [
                            {
                              required: true,
                              message: t("Please enter Group Name"),
                            },
                          ],
                        }
                      )(<Input />)}
                    </Form.Item>
                    <Form.Item label={t("Group Status")} {...formItemLayout}>
                      {getFieldDecorator("groupStatus", {
                        initialValue:
                          groupAccount.groupStatus == "INT"
                            ? null
                            : groupAccount.groupStatus,
                        rules: [
                          {
                            required: true,
                            message: t("Please enter Group Status"),
                          },
                        ],
                      })(
                        <Select
                          onChange={(value) => this.handleStatusChange(value)}
                        >
                          <Option value="ACT">{t("Active")}</Option>
                          <Option value="SUS">{t("Suspend")}</Option>
                          {/* <Option value="INT">Initial</Option> */}
                        </Select>
                      )}
                    </Form.Item>
                    <Form.Item label={t("Group Type")} {...formItemLayout}>
                      <label>
                        {" "}
                        {groupAccount.groupType === "SXG"
                          ? t("AgentGroup")
                          : null}
                        {groupAccount.groupType === "IBG" ? t("InBound") : null}{" "}
                      </label>
                    </Form.Item>
                    {groupAccount.groupType === "SXG" ? (
                      <div>
                        <Form.Item label={t("Switch Mode")} {...formItemLayout}>
                          {getFieldDecorator(
                            "cfg",
                            {
                              initialValue: { selectedValueSM },
                            },
                            {
                              rules: [
                                {
                                  required: true,
                                  message: t("Please enter Switch Mode"),
                                },
                              ],
                            }
                          )}

                          <Select
                            defaultValue={selectedValueSM}
                            style={{ width: 170 }}
                            onChange={(value) =>
                              this.handleSMDropdownChange(value)
                            }
                          >
                            <Option value="0"> {t("Round Robin")}</Option>
                            <Option value="1">{t("Most Idle Time")}</Option>
                            <Option value="2">{t("Least Received Calls")}</Option>
                          </Select>
                        </Form.Item>
                        {/* <Form.Item label="Select Agent Number" {...formItemLayout}>
                    {getFieldDecorator(
                      "selectAgentNumbers",
                      {
                        initialValue: selectedAgentNumberForAgentGroup
                      },
                      {
                        rules: [
                          {
                            required: true,
                            message: "Please select agent number"
                          }
                        ]
                      }
                    )(
                      <Select
                        mode="multiple" 
                        placeholder="Select Number"
                        value={selectedAgentNumberForAgentGroup}
                        onChange={value => this.handleChangeAgentsNumberForAgentGroup(value)}
                        style={{ width: "100%" }}
                      >
                        {accountUsers.map(item => (
                          <Select.Option key={item.userId} value={item.userNumber}>
                            {item.userName + ": " + item.userNumber}
                          </Select.Option>
                        ))}
                      </Select>
                    )}
                  </Form.Item> */}

                        {/* <Form.Item
                      label="Number Of Concurrent Calls"
                      {...formItemLayout}
                    >
                      {getFieldDecorator(
                        "agentNumberOfConcCalls",

                        {
                          initialValue: selectedNumberOfConcurrentCalls,
                        },
                        {
                          rules: [
                            {
                              required: true,
                              message:
                                "Please enter Number Of Concurrent Calls",
                            },
                          ],
                        }
                      )(
                        <InputNumber
                          min={0}
                          max={accountNumberOfConcurrentCalls}
                        />
                      )}
                    </Form.Item> */}
                      </div>
                    ) : null}

                    {groupAccount.groupType === "IBG" ? (
                      <div>
                        <Form.Item
                          label={t("Number Of Concurrent Calls")}
                          {...formItemLayout}
                        >
                          {getFieldDecorator(
                            "numberOfConcCalls",
                            {
                              initialValue: selectedNumberOfConcurrentCalls,
                            },
                            {
                              rules: [
                                {
                                  required: true,
                                  message: t(
                                    "Please enter Number Of Concurrent Calls"
                                  ),
                                },
                              ],
                            }
                          )(
                            <Select
                              style={{ width: 120 }}
                              onChange={(value) =>
                                this.handleConCallDropdownChange(value)
                              }
                            >
                              {numberOfConcCallsList}
                            </Select>
                          )}
                        </Form.Item>

                        <Form.Item
                          label={t("Select Number")}
                          {...formItemLayout}
                        >
                          {getFieldDecorator(
                            "selectNumbers",
                            {
                              initialValue: [selectedValueGroupNumbers],
                            },
                            {
                              rules: [
                                {
                                  required: true,
                                  message: t("Please enter group number"),
                                },
                              ],
                            }
                          )(
                            <div>
                              <Select
                                // mode="multiple"
                                placeholder={t("Select Number")}
                                value={selectedValueGroupNumbers}
                                onChange={(value) =>
                                  this.handleChangeAgentsNumber(value)
                                }
                                style={{ width: "100%" }}
                              >
                                {usersNumbers.map((item) => (
                                  <Select.Option key={item} value={item}>
                                    {item}
                                  </Select.Option>
                                ))}
                              </Select>
                            </div>
                          )}
                        </Form.Item>
                        <Form.Item
                          label={t("Call Flow")}
                          {...formItemLayout}
                          extra={t(
                            "If you change it the One step call flow for this group will be Deactivated."
                          )}
                        >
                          {getFieldDecorator(
                            "CallFlow",
                            {
                              initialValue: t(
                                this.state.selectedValueCallFlowId
                              ),
                            },
                            {
                              rules: [
                                {
                                  required: true,
                                  message: t("Please enter Call Flow"),
                                },
                              ],
                            }
                          )(
                            <AutoComplete
                              className="certain-category-search"
                              dropdownClassName="certain-category-search-dropdown"
                              dropdownMatchSelectWidth={false}
                              dropdownStyle={{ width: 300 }}
                              size="large"
                              style={{ width: "100%" }}
                              placeholder={t("enter here")}
                              dataSource={options}
                              disabled={this.state.readyFlow}
                              onSelect={this.onSelect}
                              filterOption={(inputValue, option) =>
                                option.props.children
                                  .toUpperCase()
                                  .indexOf(inputValue.toUpperCase()) !== -1
                              }
                            >
                              <Input
                                suffix={
                                  <Icon
                                    type="search"
                                    className="certain-category-icon"
                                  />
                                }
                              />
                            </AutoComplete>
                          )}
                        </Form.Item>
                        {/* <Form.Item label="Ready Flow" {...formItemLayout}>
                      <label> {selectedValueReadyFlow} </label>
                    </Form.Item> */}
                        <Form.Item label={t("Ready Flow")} {...formItemLayout}>
                          {getFieldDecorator(
                            "readyFlow",
                            {
                              initialValue:
                                selectedValueReadyFlow === "ONE_STEP"
                                  ? true
                                  : false,
                            },
                            {
                              rules: [
                                {
                                  required: false,
                                  message: "",
                                },
                              ],
                            }
                          )(
                            <Checkbox
                              checked={this.state.readyFlow}
                              onChange={(e) => {
                                this.handleReadyFlowCheckBox(e);
                              }}
                            ></Checkbox>
                          )}
                        </Form.Item>
                        {this.state.readyFlow ? (
                          <div>
                            <Form.Item
                              label={t("Welcome Message")}
                              {...formItemLayout}
                            >
                              {getFieldDecorator("welcomePrompt", {
                                initialValue:
                                  this.state.cfgOneStep != null
                                    ? this.state.cfgOneStep.welcomePrompt
                                    : "",

                                rules: [
                                  {
                                    required: true,
                                    message: t("Please select welcome message"),
                                  },
                                ],
                              })(
                                <Select style={{ width: "100%" }}>
                                  {promptOptions}
                                </Select>
                              )}
                            </Form.Item>

                            <Form.Item
                              label={t("Waiting Message")}
                              {...formItemLayout}
                            >
                              {getFieldDecorator("waitingPrompt", {
                                initialValue:
                                  this.state.cfgOneStep != null
                                    ? this.state.cfgOneStep.waitingPrompt
                                    : "",

                                rules: [
                                  {
                                    required: true,
                                    message: t("Please select waiting message"),
                                  },
                                ],
                              })(
                                <Select
                                  style={{ width: "100%" }}
                                  // onChange={(value) =>
                                  //   this.handleDropdownChange(value)
                                  // }
                                >
                                  {promptOptions}
                                </Select>
                              )}
                            </Form.Item>

                            <Form.Item
                              label={t("Agent Group Name")}
                              {...formItemLayout}
                            >
                              {getFieldDecorator("sxgGroupId", {
                                initialValue:
                                  this.state.cfgOneStep != null
                                    ? this.state.cfgOneStep.sxgGroupId
                                    : "",
                                rules: [
                                  {
                                    required: true,
                                    message: t("Please select Agent Group"),
                                  },
                                ],
                              })(
                                <Select
                                  style={{ width: "100%" }}
                                  // onChange={(value) =>
                                  //   this.handleDropdownChange(value)
                                  // }
                                >
                                  {agentGroupOptions}
                                </Select>
                              )}
                            </Form.Item>
                          </div>
                        ) : (
                          <></>
                        )}
                        <Form.Item
                          label={t("Activate VoiceMail")}
                          {...formItemLayout}
                        >
                          {getFieldDecorator(
                            "activateVoicemail",
                            {
                              initialValue: this.state.activateVoiceMail,
                            },
                            {
                              rules: [
                                {
                                  required: false,
                                  message: "",
                                },
                              ],
                            }
                          )(
                            <Checkbox
                              checked={this.state.activateVoiceMail}
                              onChange={(e) => {
                                this.handleActivateVoiceCheckBox(e);
                              }}
                            ></Checkbox>
                          )}
                        </Form.Item>
                        {this.state.activateVoiceMail ? (
                          <div>
                            <Form.Item
                              label={t("Working Days")}
                              {...formItemLayout}
                            >
                              {getFieldDecorator("workingDays", {
                                initialValue: workingDays
                                  ? workingDays.split(",")
                                  : [],
                                rules: [
                                  {
                                    required: true,
                                    message: t("Please select working days"),
                                  },
                                ],
                              })(
                                <Select
                                  mode="multiple"
                                  allowClear
                                  style={{ width: "100%" }}
                                  placeholder={t("Please select working days")}
                                  onChange={(values) => {
                                    this.handleWorkingdDaysChange(values);
                                  }}
                                  // defaultValue={this.mapWorkingDays(workingDays)}
                                  //options={WorkingOptions}
                                >
                                  <Option value="0">{t("Sunday")}</Option>
                                  <Option value="1">{t("Monday")}</Option>
                                  <Option value="2">{t("Tuesday")}</Option>
                                  <Option value="3">{t("Wednesday")}</Option>
                                  <Option value="4">{t("Thursday")}</Option>
                                  <Option value="5">{t("Friday")}</Option>
                                  <Option value="6">{t("Saturday")}</Option>
                                </Select>
                              )}
                            </Form.Item>
                            <Form.Item
                              label={t("Start Working Hour")}
                              {...formItemLayout}
                            >
                              {getFieldDecorator(
                                "startWorkingHour",

                                {
                                  initialValue:
                                    this.state.endHour === ""
                                      ? ""
                                      : moment(this.state.startHour, "HH:mm"),
                                  rules: [
                                    {
                                      required: true,
                                      message: t(
                                        "Please select start working hour"
                                      ),
                                    },
                                  ],
                                }
                              )(
                                <TimePicker
                                  placeholder={t("Start time")}
                                  // defaultValue={moment("8:00", format)}
                                  format={format}
                                />
                              )}
                            </Form.Item>
                            <Form.Item
                              label={t("End Working Hour")}
                              {...formItemLayout}
                            >
                              {getFieldDecorator(
                                "endWorkingHour",

                                {
                                  initialValue:
                                    this.state.endHour === ""
                                      ? ""
                                      : moment(this.state.endHour, "HH:mm"),
                                  rules: [
                                    {
                                      required: true,
                                      message: t(
                                        "Please select end working hour"
                                      ),
                                    },
                                  ],
                                }
                              )(
                                <TimePicker
                                  placeholder={t("End time")}
                                  // defaultValue={moment("8:00", format)}
                                  format={format}
                                />
                              )}
                            </Form.Item>
                            <Form.Item
                              label={t("VoiceMail Message")}
                              {...formItemLayout}
                            >
                              {getFieldDecorator("voiceMailMessage", {
                                initialValue: this.state
                                  .selectedVoiceMailMessage
                                  ? this.state.selectedVoiceMailMessageForView
                                  : "",

                                rules: [
                                  {
                                    required: true,
                                    message: t(
                                      "Please select a voicemail message"
                                    ),
                                  },
                                ],
                              })(
                                <Select
                                  style={{ width: "100%" }}
                                  // onChange={(value) =>
                                  //   this.handleVoicemailMsgSelect(value)
                                  // }
                                >
                                  {promptOptions}
                                </Select>
                              )}
                            </Form.Item>
                          </div>
                        ) : null}
                      </div>
                    ) : null}
                    <Form.Item
                      wrapperCol={{
                        xs: { span: 24, offset: 0 },
                        sm: { span: 16, offset: 8 },
                      }}
                    >
                      {/* <Button
                    className="button-submit"
                    type="primary"
                    onClick={this.handleConfirm}
                    size={"small"}
                    loading={this.state.loading}
                  >
                    Submit
                  </Button> */}
                      <Popconfirm
                        title={
                          this.props.form.getFieldValue("CallFlow") ||
                          this.readyFlow ||
                          groupAccount.groupType == "SXG"
                            ? t("Are you sure you want to update the group?")
                            : t(
                                "Are you sure you want to update the group without callflow? it will be suspended"
                              )
                        }
                        onConfirm={this.handleConfirm}
                        okText={t("Yes")}
                        cancelText={t("No")}
                      >
                        <Button
                          className="button-submit"
                          type="primary"
                          // onClick={this.handleConfirm}
                          size={"small"}
                          loading={this.state.loading}
                        >
                          {t("Submit")}
                        </Button>
                      </Popconfirm>
                    </Form.Item>
                  </Form>
                </Card>

                {groupAccount.groupType === "SXG" ? (
                  <UsersTable
                    groupId={this.props.match.params}
                    onRefresh={() => this.handleRefresh()}
                  ></UsersTable>
                ) : null}
              </div>
            )}
          </Page>
        )}
      </Translation>
    );
  }
}
export default Form.create()(
  withSharedStateConsumer(withRouter(UpdateGroupAccount))
);
